import React from "react";
import { IntlShape } from "react-intl";

import { translateMessage } from "src/app/methods/translateMessage";
import { ProjectSetupType } from "../types";
import FormSection from "./FormSection";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { CustomInputLabel } from "src/app/components/CustomInput/CustomInput";
import CustomSelect from "src/app/components/CustomSelect/CustomSelect";
import { currencySearchFunction } from "src/app/components/CustomSelect/functions/currencySearchFunction";

interface CurrencyOption {
  key: string;
  label: React.JSX.Element;
  value: string;
}

interface SettingsSectionProps {
  currentSetup: ProjectSetupType;
  selectedCurrency: string | null;
  onCurrencyChange: (currency: string | null) => void;
  currencyOptions: CurrencyOption[];
  intl: IntlShape;
}

export default function SettingsSection({
  currentSetup,
  selectedCurrency,
  onCurrencyChange,
  currencyOptions,
  intl,
}: SettingsSectionProps) {
  if (currentSetup === ProjectSetupType.BasedOnExistingProject) {
    return null;
  }

  return (
    <FormSection
      title={<IDHFormattedMessage id="ws_settings" defaultMessage="Settings" />}
      dataQa="project-currency-select"
    >
      <div>
        <CustomInputLabel required>
          <IDHFormattedMessage id="ws_currency" defaultMessage="Currency" />
        </CustomInputLabel>
        <CustomSelect
          id="currency"
          isSearchable
          value={
            currencyOptions.find((opt) => opt.value === selectedCurrency) ??
            null
          }
          onChange={(opt: CurrencyOption) => onCurrencyChange(opt.value)}
          options={currencyOptions}
          placeholder={translateMessage({
            intl,
            id: "ws_select_currency",
            defaultMessage: "Select currency",
          })}
          filterOption={currencySearchFunction}
        />
      </div>
    </FormSection>
  );
}
